
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./App": () => {
return Promise.all(/*  | __federation_expose_App */ [__webpack_require__.e("787"), __webpack_require__.e("712"), __webpack_require__.e("362")]).then(() => (() => (__webpack_require__(465))));
},
"./RxInput": () => {
return Promise.all(/*  | __federation_expose_RxInput */ [__webpack_require__.e("787"), __webpack_require__.e("728"), __webpack_require__.e("712"), __webpack_require__.e("135"), __webpack_require__.e("916"), __webpack_require__.e("567")]).then(() => (() => (__webpack_require__(7285))));
},
"./RxHistory": () => {
return Promise.all(/*  | __federation_expose_RxHistory */ [__webpack_require__.e("787"), __webpack_require__.e("728"), __webpack_require__.e("712"), __webpack_require__.e("135"), __webpack_require__.e("162"), __webpack_require__.e("267")]).then(() => (() => (__webpack_require__(8985))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };